import type { TradeDeskTradeBlotterConfig } from '@/types/schema/page-configs/trade-desk-trade-blotter'

import {
  RowClickBehavior,
  ViewType,
} from '@/types/schema/page-configs/trade-blotter'

export const defaultTradeDeskTradeBlotterConfig: TradeDeskTradeBlotterConfig = {
  rowClickBehavior: RowClickBehavior.Preview,
  viewType: ViewType.Standard,
}
